// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// const SearchBar = () => {
//   const [query, setQuery] = useState('');
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//   const navigate = useNavigate();

//   const eventNames = [
//     'Jodhpuri Suits',
//     'Suits & Tuxedos',
//     'Blazers',
//     'Ethnic Jackets & Kurta Pyjama',
//     'Indowestern & Sherwani',
//     'Accessories',
//     'Graduation/Farewell',
//     'Office Event',
//     'Party-Wear',
//     'Ethnic Day',
//     'PreWedding Photoshoot',
//     'Attending Wedding',
//     'Weddings'
//   ];

//   const handleInputChange = (event) => {
//     const value = event.target.value;
//     setQuery(value);

//     if (value) {
//       const filtered = eventNames.filter((name) =>
//         name.toLowerCase().includes(value.toLowerCase())
//       );
//       setFilteredSuggestions(filtered);
//     } else {
//       setFilteredSuggestions([]);
//     }
//   };

//   const handleSuggestionClick = (suggestion) => {
//     setQuery(suggestion);
//     setFilteredSuggestions([]);
//     navigate('/products', { state: { selectedStyle: suggestion } });
//   };

//   return (
//     <div
//       style={{
//         position: 'relative',
//         maxWidth: '600px',
//         margin: '0 auto',
//         padding: '30px',
//         backgroundColor: '#f9f9f9',
//         borderRadius: '12px',
//         boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
//         transition: 'all 0.3s ease-in-out'
//       }}
//     >
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           marginBottom: '20px',
//           color: '#333333',
//           fontWeight: 'bold',
//           fontSize: '24px'
//         }}
//       >
//         Search for your Perfect Style
//       </div>
//       <div
//         style={{
//           position: 'relative'
//         }}
//       >
//         <input
//           type="text"
//           value={query}
//           onChange={handleInputChange}
//           placeholder="Search for event styles, occasions, and outfits..."
//           style={{
//             width: '100%',
//             padding: '16px 20px 16px 44px',
//             fontSize: '18px',
//             border: 'none',
//             borderRadius: '8px',
//             outline: 'none',
//             backgroundColor: '#ffffff',
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//             transition: 'box-shadow 0.3s ease-in-out'
//           }}
//         />
//         <div
//           style={{
//             position: 'absolute',
//             top: '50%',
//             left: '16px',
//             transform: 'translateY(-50%)',
//             color: '#999999'
//           }}
//         >
//           🔍
//         </div>
//       </div>

//       {filteredSuggestions.length > 0 && (
//         <div
//           style={{
//             position: 'absolute',
//             top: 'calc(100% + 10px)',
//             left: '0',
//             width: '100%',
//             maxHeight: '300px',
//             overflowY: 'auto',
//             backgroundColor: '#ffffff',
//             borderRadius: '8px',
//             boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
//             zIndex: '10',
//             transition: 'all 0.3s ease-in-out'
//           }}
//         >
//           {filteredSuggestions.map((suggestion, index) => (
//             <div
//               key={index}
//               style={{
//                 padding: '14px 20px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 color: '#333333',
//                 transition: 'background-color 0.2s ease, color 0.2s ease'
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = '#f2f2f2';
//                 e.currentTarget.style.color = '#007bff';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = 'transparent';
//                 e.currentTarget.style.color = '#333333';
//               }}
//               onClick={() => handleSuggestionClick(suggestion)}
//             >
//               {suggestion}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchBar;



// import React, { useState } from 'react';
// import { BiCategoryAlt } from "react-icons/bi";
// import { IoSearchOutline } from "react-icons/io5";
// import { MdOutlineAccountCircle } from "react-icons/md";
// import { FaShoppingCart } from "react-icons/fa";
// import { IoHome } from "react-icons/io5";
// import { useNavigate } from 'react-router-dom';
// import { FaSearch } from 'react-icons/fa';
// import "./SearchBar.css"
// const SearchBar = () => {
//   const [query, setQuery] = useState('');
//   const [filteredSuggestions, setFilteredSuggestions] = useState([]);
//   const navigate = useNavigate();

//   const eventNames = [
//     'Jodhpuri Suits',
//     'Suits & Tuxedos',
//     'Blazers',
//     'Ethnic Jackets & Kurta Pyjama',
//     'Indowestern & Sherwani',
//     'Accessories',
//     'Graduation/Farewell',
//     'Office Event',
//     'Party-Wear',
//     'Ethnic Day',
//     'PreWedding Photoshoot',
//     'Attending Wedding',
//     'Weddings'
//   ];

//   const handleInputChange = (event) => {
//     const value = event.target.value;
//     setQuery(value);

//     if (value) {
//       const filtered = eventNames.filter((name) =>
//         name.toLowerCase().includes(value.toLowerCase())
//       );
//       setFilteredSuggestions(filtered);
//     } else {
//       setFilteredSuggestions([]);
//     }
//   };

//   const handleSuggestionClick = (suggestion) => {
//     setQuery(suggestion);
//     setFilteredSuggestions([]);
//     navigate('/products', { state: { selectedStyle: suggestion } });
//   };

//   return (
//     <>
//       <div className="tf-page-title">
//         <div className="heading text-center">
//           Search for your Perfect Style
//         </div>
//       </div>
//       <div className='searchcontiner'>
//         <FaSearch size={28} />
//         <input
//           type="text"
//           value={query}
//           onChange={handleInputChange}
//           placeholder="Search for event styles, occasions, and outfits..."
//           className='searchbarinput'
//         />
//       {filteredSuggestions.length > 0 && (
//         <div className='filtersuggestion'>
//           {filteredSuggestions.map((suggestion, index) => (
//             <div
//               key={index}
//               style={{
//                 padding: '14px 20px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 color: '#333333',
//                 transition: 'background-color 0.2s ease, color 0.2s ease'
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.backgroundColor = '#f2f2f2';
//                 e.currentTarget.style.color = '#007bff';
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.backgroundColor = 'transparent';
//                 e.currentTarget.style.color = '#333333';
//               }}
//               onClick={() => handleSuggestionClick(suggestion)}
//             >
//               {suggestion}
//             </div>
//           ))}
//         </div>
//       )}
//       </div>


//       <div class="tf-toolbar-bottom type-1150">
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/">
//             <div class="toolbar-icon">
//               <IoHome />
//             </div>
//             <div class="toolbar-label">Home</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/products" >
//             <div class="toolbar-icon">
//               <BiCategoryAlt />
//             </div>
//             <div class="toolbar-label">Shop</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/SearchBar" >
//             <div class="toolbar-icon">
//               <IoSearchOutline />
//             </div>
//             <div class="toolbar-label">Search</div>
//           </a>
//         </div>
//         <div class="toolbar-item">
//           <a style={{ color: "black" }} href="/cart">
//             <div class="toolbar-icon">
//               <FaShoppingCart />
//             </div>
//             <div class="toolbar-label">Cart</div>
//           </a>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SearchBar;


import React, { useState, useEffect } from 'react';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline, IoHome } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart, FaSearch } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import "./SearchBar.css";

const SearchBar = () => {
  const [query, setQuery] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [products, setProducts] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch products from API when component mounts
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("/api/all/products");
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();
        setProducts(data);
      } catch (err) {
        setError(err.message);
      }
    };
    fetchProducts();
  }, []);

  // Update suggestions based on search input
  const handleInputChange = (event) => {
    const value = event.target.value;
    setQuery(value);
  
    if (value) {
      const filtered = products
        .flatMap(product => [
          product.productName,
          product.color,
          product.category,
          ...(product.selectedStyles || [])
        ])
        .filter(name => typeof name === "string" && name.toLowerCase().includes(value.toLowerCase())); // Ensure name is a string
  
      setFilteredSuggestions([...new Set(filtered)]); // Remove duplicates
    } else {
      setFilteredSuggestions([]);
    }
  };
  

  // Handle search selection
  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion);
    setFilteredSuggestions([]);
    navigate('/products', { state: { selectedStyle: suggestion ,isFromSearch: true} });
  };

  return (
    <>
      <div className="tf-page-title">
        <div className="heading text-center">
          Search for your Perfect Style
        </div>
      </div>
      <div className='searchcontiner'>
        <FaSearch size={28} />
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          placeholder="Search for event styles, occasions, and outfits..."
          className='searchbarinput'
        />
        {filteredSuggestions.length > 0 && (
          <div className='filtersuggestion'>
            {filteredSuggestions.map((suggestion, index) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion}
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="tf-toolbar-bottom type-1150">
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/">
            <div className="toolbar-icon"><IoHome /></div>
            <div className="toolbar-label">Home</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/products">
            <div className="toolbar-icon"><BiCategoryAlt /></div>
            <div className="toolbar-label">Shop</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/SearchBar">
            <div className="toolbar-icon"><IoSearchOutline /></div>
            <div className="toolbar-label">Search</div>
          </a>
        </div>
        <div className="toolbar-item">
          <a style={{ color: "black" }} href="/cart">
            <div className="toolbar-icon"><FaShoppingCart /></div>
            <div className="toolbar-label">Cart</div>
          </a>
        </div>
      </div>
    </>
  );
};

export default SearchBar;
